import React from 'react';
import PropTypes from 'prop-types';

const RadioButtonFilter = (props) => {
  function handleChange() {
    props.setState(props.value);
  }

  return (
    <li className="form-item--radio form-item--radio__item">
      <input
        name={props.name}
        id={props.value}
        type="radio"
        value={props.value}
        defaultChecked={props.default === props.value}
        className="form-item--radio__input visually-hidden"
        onChange={handleChange}
      />
      <label
        htmlFor={props.value}
        className="form-item__label form-item__label--radio form-item__label--radio-compact"
      >
        {props.title}
      </label>
    </li>
  );
};

RadioButtonFilter.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  setState: PropTypes.func,
  default: PropTypes.string,
};

export default RadioButtonFilter;
